// Importar el módulo Tab de Bootstrap desde node_modules
import Tab from "bootstrap/js/dist/tab";

document.addEventListener("DOMContentLoaded", () => {
  // Inicializar los tabs de Bootstrap
  const tabElements = document.querySelectorAll(
    '.tabs-with-media-block button[data-bs-toggle="pill"]'
  );

  tabElements.forEach((tabElement) => {
    // Inicializar el componente Tab de Bootstrap
    new Tab(tabElement);

    tabElement.addEventListener("shown.bs.tab", (event) => {
      // Evento que se dispara cuando se muestra un nuevo tab
      const targetId = event.target.getAttribute("data-bs-target");
      const targetPane = document.querySelector(targetId);

      // Animación opcional o lógica personalizada
      if (targetPane) {
        // Puedes agregar animaciones personalizadas aquí
        console.log("Tab activado:", targetId);

        // if video, play it
        const video = targetPane.querySelector("video");
        if (video) video.play();
      }
    });

    tabElement.addEventListener("hide.bs.tab", (event) => {
      // Evento que se dispara cuando se oculta un tab
      const targetId = event.target.getAttribute("data-bs-target");
      console.log("Tab desactivado:", targetId);
      const targetPane = document.querySelector(targetId);

      // if video, pause it
      if (targetPane) {
        const video = targetPane.querySelector("video");
        if (video) video.pause();
      }
    });
  });
});
